import { useEffect, useRef, useState } from "react";
import { IconKrzyzyk, IconSzukaj } from "../icons/index.js";
import { Field } from "../ui/Field.js";

/**
 * F-10: pole wyszukiwania. Lupa wewnatrz pola po lewej (w --text-subtle), placeholder "Szukaj...", a gdy jest tresc,
 * po prawej przycisk czyszczenia (x) o polu trafienia wg A-3. Etykieta stoi nad polem (F-1): placeholder nigdy nie jest
 * jedynym nosnikiem nazwy.
 *
 * Pole ma wlasny stan tekstu i zglasza zmiane po krotkiej przerwie w pisaniu (albo od razu po Enter), zeby kazde
 * nacisniecie klawisza nie robilo zapytania do serwera. Zglaszany tekst jest PRZYCIETY, a porownania (czy cos sie zmienilo, czy
 * wartosc z zewnatrz to echo wpisanego) tez ida po przycieciu: sama koncowa spacja nie uruchamia zapytania i nie znika z pola w
 * trakcie pisania. Zmiana wartosci z zewnatrz (np. "Wyczysc filtry") zastepuje tekst.
 *
 * Po czyszczeniu krzyzykiem fokus wraca do pola (A-4): przycisk znika z DOM, a fokus nie moze wyladowac na <body>.
 */

const PRZERWA_MS = 400;

export function PoleSzukania({
  id,
  etykieta,
  wartosc,
  onZmiana,
  podpowiedz,
  maksDlugosc,
}: {
  id: string;
  etykieta: string;
  wartosc: string;
  onZmiana: (nowa: string) => void;
  /** P-4: hint pod polem (co przeszukujemy). */
  podpowiedz?: string;
  /** Najdluzszy tekst, jaki serwer przyjmie. Dluzszy konczyl sie surowym kodem bledu API, wiec pole w ogole go nie przyjmuje. */
  maksDlugosc?: number;
}): React.JSX.Element {
  const [tekst, setTekst] = useState(wartosc);
  const onZmianaRef = useRef(onZmiana);
  onZmianaRef.current = onZmiana;
  const wartoscRef = useRef(wartosc);
  const poleRef = useRef<HTMLInputElement>(null);

  // Wartosc z zewnatrz wygrywa (zmiana adresu, "Wyczysc filtry", przejscie z innego widoku), ale nie wtedy, gdy jest echem
  // tego, co uzytkownik wlasnie wpisal: po przycieciu oba sa rowne, wiec spacja na koncu zostaje w polu.
  useEffect(() => {
    wartoscRef.current = wartosc;
    setTekst((poprzedni) => (poprzedni.trim() === wartosc ? poprzedni : wartosc));
  }, [wartosc]);

  useEffect(() => {
    if (tekst.trim() === wartoscRef.current) return;
    const zegar = setTimeout(() => onZmianaRef.current(tekst.trim()), PRZERWA_MS);
    return () => clearTimeout(zegar);
  }, [tekst]);

  return (
    <Field etykieta={etykieta} id={id} hint={podpowiedz}>
      {(atrybuty) => (
        <div className="pole-szukania">
          <span className="pole-szukania__lupa" aria-hidden="true">
            <IconSzukaj size={18} />
          </span>
          <input
            {...atrybuty}
            ref={poleRef}
            type="search"
            className="input pole-szukania__input"
            placeholder="Szukaj..."
            value={tekst}
            maxLength={maksDlugosc}
            autoComplete="off"
            onChange={(e) => setTekst(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && tekst.trim() !== wartoscRef.current) onZmiana(tekst.trim());
            }}
          />
          {tekst !== "" && (
            <button
              type="button"
              className="pole-szukania__wyczysc"
              aria-label="Wyczyść wyszukiwanie"
              onClick={() => {
                setTekst("");
                wartoscRef.current = "";
                onZmiana("");
                poleRef.current?.focus();
              }}
            >
              <IconKrzyzyk size={16} />
            </button>
          )}
        </div>
      )}
    </Field>
  );
}
